import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Wrapper = styled.div(() =>
  mq({
    width: '100%',
    paddingTop: '56.25%',
    position: 'relative',
    backgroundColor: defaultTheme.background.mediumGray,
  }),
);

export const IFrame = styled.iframe(() =>
  mq({
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
  }),
);
